// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { post } from 'utils/http';
import AcceptCookies from 'components/AcceptCookies';
import { updateCurrentUser } from '../redux/main/actions/currentUser';

type OwnProps = {};

type Props = {
  ...$Exact<OwnProps>,
  currentUser: Object,
  updateCurrentUser: Function
};

type State = {
  submitting: boolean
};

class AcceptCookiesContainer extends React.PureComponent<Props, State> {
  state = {
    submitting: false
  };

  acceptCookies = () => {
    this.setState({ submitting: true });
    post('/data/website/accept-cookies').then(() => {
      this.props.updateCurrentUser({
        ...this.props.currentUser,
        showAcceptCookies: false
      });
      this.setState({ submitting: false });
    });
  };

  render() {
    if (!this.props.currentUser.showAcceptCookies) return null;
    return (
      <AcceptCookies
        acceptCookies={this.acceptCookies}
        submitting={this.state.submitting}
      />
    );
  }
}

const mapStateToProps = ({ currentUser }) => ({ currentUser });

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  { updateCurrentUser }
)(AcceptCookiesContainer);
